import { useLingui } from '@lingui/react';
import { Button, Group, Image, NumberFormatter, Table, Text } from '@mantine/core';
export type WalletTableRowProps = {
  coinImage: string;
  coinName: string;
  balance: number;
  coin: string;
  value: number;
};
export const WalletTableRow: React.FC<WalletTableRowProps> = ({
  coinImage,
  coinName,
  balance,
  coin,
  value
}) => {
  const {
    i18n
  } = useLingui();
  return <Table.Tr key={coinImage}>
      <Table.Td miw={130} w={180}>
        <Group gap={4}>
          <Image src={coinImage} alt="coin" w={{
          base: 36,
          sm: 38
        }} h={{
          base: 36,
          sm: 38
        }} />
          <Text tt="capitalize" fz={{
          base: 10,
          md: 13
        }} c="var(--text-dark)">
            {coinName}
          </Text>
        </Group>
      </Table.Td>

      <Table.Td miw={{
      base: 90,
      sm: 130
    }}>
        <Text fz={{
        base: 10,
        md: 13
      }} c="var(--text-prime)">
          <NumberFormatter value={balance} thousandSeparator="," decimalSeparator="." />
          <Text span inherit c="var(--text-dark)" ml={4} visibleFrom="md">
            {coin}
          </Text>
        </Text>
      </Table.Td>

      <Table.Td miw={90} w={250}>
        <Text fw={500} fz={{
        base: 10,
        md: 13
      }} c="var(--text-dark)">
          <NumberFormatter prefix="$" value={value} suffix={' USD'} thousandSeparator="," decimalSeparator="." decimalScale={2} fixedDecimalScale />
        </Text>
      </Table.Td>

      <Table.Td visibleFrom="sm">
        <Button fw={500} fz={13} c="var(--text-dark)" variant="transparent">
          {i18n._('Deposit')}
        </Button>
      </Table.Td>

      <Table.Td visibleFrom="sm">
        <Button fw={500} fz={13} c="var(--text-dark)" variant="transparent">
          {i18n._('Withdraw')}
        </Button>
      </Table.Td>
    </Table.Tr>;
};